import ErrorIe from '@/views/ErrorIe.vue';
import Linking from '@/views/Linking.vue';
import { auths, actors } from '@/router/options';

const routes: any[] = [
  {
    path: '/error-ie',
    component: ErrorIe,
    meta: {
      title: 'Internet Explorerは非推奨です',
      actor: actors.none,
      auth: auths.noRequired,
    },
  },
  {
    path: '/linking',
    component: Linking,
    meta: {
      title: 'linking...',
      actor: actors.none,
      auth: auths.noRequired,
    },
  },
];

export default {
  routes,
};
